<div class="flex flex-col gap-6">
  <div class="flex flex-col gap-3">
    <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">
      Check your <span class="text-primary">inbox</span>
    </h1>
    <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">
      Enter the 6-digit code we sent to <strong>{{ onboarding.draft().email }}</strong>.
      <button type="button" class="font-bold text-primary" (click)="changeEmail()">Change</button>
    </p>
  </div>

  <div class="relative">
    <div class="grid grid-cols-6 gap-2" aria-hidden="true">
      @for (box of boxes; track box) {
        <div class="flex h-16 items-center justify-center rounded-lg border bg-card text-3xl font-bold text-foreground" [class]="boxClass(box)">
          {{ digit(box) }}
        </div>
      }
    </div>
    <label class="sr-only" for="vfa-code">6-digit code</label>
    <input
      #codeInput
      id="vfa-code"
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="6"
      class="absolute inset-0 cursor-text text-base opacity-0"
      autofocus
      [value]="code()"
      (input)="onCode($event)" />
  </div>

  @if (onboarding.verifying()) {
    <p class="m-0 flex items-center gap-2 text-lg font-bold text-primary">
      <span class="size-4 animate-spin rounded-full border-2 border-primary/20 border-t-primary" aria-hidden="true"></span>
      Verifying and creating your agency…
    </p>
  }
  @if (onboarding.error()) {
    <p class="m-0 text-base font-semibold text-red-600 dark:text-red-400" role="alert">{{ onboarding.error() }}</p>
  }

  <p class="m-0 text-base font-semibold text-muted-foreground">
    Didn't get it?
    <button type="button" class="font-bold text-primary disabled:opacity-50" [disabled]="onboarding.resendCooldown() > 0 || onboarding.sendingCode()" (click)="resend()">
      @if (onboarding.resendCooldown() > 0) {
        Resend code ({{ onboarding.resendCooldown() }})
      } @else {
        Resend code
      }
    </button>
  </p>
</div>
